import React, { useContext, useState, useEffect } from 'react'
import { Alert, Autocomplete, Box, Button, Checkbox, Chip, Dialog, DialogContent, FormControl, InputLabel, MenuItem, Select, TextField, Typography, useTheme } from '@mui/material';
import { Formik } from "formik";
import * as yup from "yup";
import YupPassword from 'yup-password';
import axios from 'axios';
import { tokens } from '../../../../theme';
import { UserContext } from '../../../../context/UserContext';
import ProgressDialog from '../../../../components/ProgressDialog';
YupPassword(yup);

function RegisterDialog({ open, handleClose, handleCloseWithAccesDialogOpen, type, brand, isAddingFromAdminPanel }) {
  const theme = useTheme();
  const colors = tokens(theme.palette.colors);
  const { token } = useContext(UserContext);
  const [alertMessage, setAlertMessage] = useState(null);
  const [data, setData] = useState(null);
  const [usingProvider, setUsingProvider] = useState(false);

  const [progress, setProgress] = useState(0);
  const [progressDialogOpen, setProgressDialogOpen] = useState(false);

  useEffect(() => {
    if (progress === 100) {
      // if (type === "new" && !isAddingFromAdminPanel && data && data.brand.webservice_provider === "ideasoft") {
      //   setProgressDialogOpen(false);
      //   handleCloseWithAccesDialogOpen(data);
      // } else {
      //   setProgressDialogOpen(false);
      //   handleClose();
      // }
      setProgressDialogOpen(false);
      handleClose();
    }
  }, [progress]);

  var initialValues = {}

  if (type === "new") {
    if (isAddingFromAdminPanel) {
      initialValues = {
        brandName: "",
        website: "",
        webservice_provider: "",
        webservice_address: "",
        webservice_username: "",
        webservice_password: "",
        client_id: "",
        client_secret: "",
        brandDescription: "",
        keywords: [],
        commission: 0,
        logoSquare: null,
        logoHorizontal: null,
        logoHorizontalBig: null,
        logoVertical: null,
        logoStrip: null,
        logoSquareLink: "",
        logoHorizontalLink: "",
        logoHorizontalBigLink: "",
        logoVerticalLink: "",
        logoStripLink: "",
        refCode: "",
        name: "",
        surname: "",
        email: "",
        password: "",
        passwordCheck: "",
        couponDistributionPercentage: 0,
        conversionPercentage: 0,
        avarageBasketAmount: 0,
        sectorName: "",
        legal_name: "",
        tax_no: "",
        company_address: "",
        company_phone_number: "",
        company_email: "",
        company_kep: "",
        return_email: "",
        return_address: "",
        sales_type: "digital",
      }
    } else {
      initialValues = {
        brandName: "",
        website: "",
        webservice_provider: "",
        webservice_address: "",
        webservice_username: "",
        webservice_password: "",
        client_id: "",
        client_secret: "",
        brandDescription: "",
        keywords: [],
        logoSquare: null,
        logoHorizontal: null,
        logoHorizontalBig: null,
        logoVertical: null,
        logoStrip: null,
        logoSquareLink: "",
        logoHorizontalLink: "",
        logoHorizontalBigLink: "",
        logoVerticalLink: "",
        logoStripLink: "",
        refCode: "",
        name: "",
        surname: "",
        email: "",
        password: "",
        passwordCheck: "",
        legal_name: "",
        tax_no: "",
        company_address: "",
        company_phone_number: "",
        company_email: "",
        company_kep: "",
        return_email: "",
        return_address: "",
        sales_type: "digital",
      }
    }
  }

  if (type === "edit" || type === "approve") {
    initialValues = {
      brandName: brand.name,
      website: brand.website,
      brandDescription: brand.description,
      keywords: brand.keywords.split(";"),
      commission: brand.commission_percentage ? brand.commission_percentage : 0,
      logoSquare: null,
      logoHorizontal: null,
      logoHorizontalBig: null,
      logoVertical: null,
      logoStrip: null,
      logoSquareLink: brand.logo_link,
      logoHorizontalLink: brand.horizontal_logo_link,
      logoHorizontalBigLink: brand.big_horizontal_logo_link,
      logoVerticalLink: brand.vertical_logo_link,
      logoStripLink: brand.strip_logo_link,
      couponDistributionPercentage: brand.coupon_distribution_percentage ? brand.coupon_distribution_percentage : 0,
      conversionPercentage: brand.conversion_percentage ? brand.conversion_percentage : 0,
      avarageBasketAmount: brand.avarage_basket_amount ? brand.avarage_basket_amount : 0,
      sectorName: brand.sector_name ? brand.sector_name : ""
    }
  }

  var validationObject = {}

  if (type === "new") {
    validationObject = {
      brandName: yup.string().required("zorunlu"),
      website: yup.string().url("Geçersiz url! (örn: https://markaniz.com/").required("zorunlu"),
      webservice_provider: usingProvider ? yup.string().required() : yup.string(),
      webservice_address: yup.string().url("Geçersiz url! (örn: https://markaniz.com/").when('webservice_provider', {
        is: (webservice_provider) => webservice_provider && webservice_provider === "tsoft",
        then: yup.string().url("Geçersiz url! (örn: https://markaniz.com/")
          .required('zorunlu')
      }),
      webservice_username: yup.string().when('webservice_provider', {
        is: (webservice_provider) => webservice_provider && (webservice_provider === "tsoft" || webservice_provider === "ikas"),
        then: yup.string()
          .required('zorunlu')
      }),
      webservice_password: yup.string().when('webservice_provider', {
        is: (webservice_provider) => webservice_provider && webservice_provider === "tsoft",
        then: yup.string()
          .required('zorunlu')
      }),
      client_id: yup.string().when('webservice_provider', {
        is: (webservice_provider) => webservice_provider && webservice_provider === "ikas",
        then: yup.string()
          .required('zorunlu')
      }),
      client_secret: yup.string().when('webservice_provider', {
        is: (webservice_provider) => webservice_provider && webservice_provider === "ikas",
        then: yup.string()
          .required('zorunlu')
      }),
      brandDescription: yup.string().required("zorunlu"),
      keywords: yup.array().min(15, "En az 15 kelime girilmesi gerekmektedir. Kelimeyi girdikten sonra enter tuşuna basarak onaylayabilirsiniz.").required("zorunlu"),
      logoSquareLink: yup.string(),
      logoSquare: yup.mixed().when('logoSquareLink', {
        is: (logoSquareLink) => !logoSquareLink || logoSquareLink === "",
        then: yup.string()
          .required('zorunlu')
      }),
      logoHorizontalLink: yup.string(),
      logoHorizontal: yup.mixed().when('logoHorizontalLink', {
        is: (logoHorizontalLink) => !logoHorizontalLink || logoHorizontalLink === "",
        then: yup.string()
          .required('zorunlu')
      }),
      logoHorizontalBigLink: yup.string(),
      logoHorizontalBig: yup.mixed().when('logoHorizontalBigLink', {
        is: (logoHorizontalBigLink) => !logoHorizontalBigLink || logoHorizontalBigLink === "",
        then: yup.string()
          .required('zorunlu')
      }),
      logoVerticalLink: yup.string(),
      logoVertical: yup.mixed().when('logoVerticalLink', {
        is: (logoVerticalLink) => !logoVerticalLink || logoVerticalLink === "",
        then: yup.string()
          .required('zorunlu')
      }),
      logoStripLink: yup.string(),
      logoStrip: yup.mixed().when('logoStripLink', {
        is: (logoStripLink) => !logoStripLink || logoStripLink === "",
        then: yup.string()
          .required('zorunlu')
      }),
      refCode: yup.string(),
      name: yup.string().required("zorunlu"),
      surname: yup.string().required("zorunlu"),
      email: yup.string().email("Geçersiz eposta adresi").required("zorunlu"),
      password: yup.string()
        .required('zorunlu')
        .min(8, 'Şifre çok kısa - en az 8 karakter olmalı')
        .minLowercase(1, 'Şifreniz en az 1 küçük harf içermelidir')
        .minUppercase(1, 'Şifreniz en az 1 büyük harf içermelidir')
        .minNumbers(1, 'Şifreniz en az 1 rakam içermelidir')
        .minSymbols(1, 'Şifreniz en az 1 özel karakter içermelidir'),
      passwordCheck: yup.string()
        .oneOf([yup.ref('password'), null], 'Şifreler uyuşmuyor'),
      legal_name: yup.string().required("zorunlu"),
      tax_no: yup.string().required("zorunlu"),
      company_address: yup.string().required("zorunlu"),
      company_phone_number: yup.string().required("zorunlu"),
      company_email: yup.string().email("Geçersiz eposta adresi").required("zorunlu"),
      company_kep: yup.string().email("Geçersiz eposta adresi").required("zorunlu"),
      return_email: yup.string().email("Geçersiz eposta adresi").required("zorunlu"),
      return_address: yup.string().required("zorunlu"),
      sales_type: yup.string().required("zorunlu"),
    }

    if (isAddingFromAdminPanel) {
      validationObject.commission = yup.number().min(0, "En az 0 olabilir").max(100, "En fazla 100 olabilir").required("zorunlu");
      validationObject.couponDistributionPercentage = yup.number().min(0, "En az 0 olabilir").max(100, "En fazla 100 olabilir").required("zorunlu");
      validationObject.conversionPercentage = yup.number().min(0, "En az 0 olabilir").max(100, "En fazla 100 olabilir").required("zorunlu");
      validationObject.avarageBasketAmount = yup.number().min(0, "En az 0 olabilir").required("zorunlu");
      validationObject.sectorName = yup.string().required("zorunlu");
    }
  }

  if (type === "edit" || type === "approve") {
    validationObject = {
      brandName: yup.string().required("zorunlu"),
      website: yup.string().url("Geçersiz url! (örn: https://markaniz.com/").required("zorunlu"),
      brandDescription: yup.string().required("zorunlu"),
      keywords: yup.array().min(15, "En az 15 kelime girilmesi gerekmektedir. Kelimeyi girdikten sonra enter tuşuna basarak onaylayabilirsiniz.").required("zorunlu"),
      commission: yup.number().min(0, "En az 0 olabilir").max(100, "En fazla 100 olabilir").required("zorunlu"),
      logoSquareLink: yup.string(),
      logoSquare: yup.mixed().when('logoSquareLink', {
        is: (logoSquareLink) => !logoSquareLink || logoSquareLink === "",
        then: yup.string()
          .required('zorunlu')
      }),
      logoHorizontalLink: yup.string(),
      logoHorizontal: yup.mixed().when('logoHorizontalLink', {
        is: (logoHorizontalLink) => !logoHorizontalLink || logoHorizontalLink === "",
        then: yup.string()
          .required('zorunlu')
      }),
      logoHorizontalBigLink: yup.string(),
      logoHorizontalBig: yup.mixed().when('logoHorizontalBigLink', {
        is: (logoHorizontalBigLink) => !logoHorizontalBigLink || logoHorizontalBigLink === "",
        then: yup.string()
          .required('zorunlu')
      }),
      logoVerticalLink: yup.string(),
      logoVertical: yup.mixed().when('logoVerticalLink', {
        is: (logoVerticalLink) => !logoVerticalLink || logoVerticalLink === "",
        then: yup.string()
          .required('zorunlu')
      }),
      logoStripLink: yup.string().nullable(),
      logoStrip: yup.mixed().when('logoStripLink', {
        is: (logoStripLink) => !logoStripLink || logoStripLink === "",
        then: yup.string()
          .required('zorunlu')
      }),
      couponDistributionPercentage: yup.number().min(0, "En az 0 olabilir").max(100, "En fazla 100 olabilir").required("zorunlu"),
      conversionPercentage: yup.number().min(0, "En az 0 olabilir").max(100, "En fazla 100 olabilir").required("zorunlu"),
      avarageBasketAmount: yup.number().min(0, "En az 0 olabilir").required("zorunlu"),
      sectorName: yup.string().required("zorunlu")
    }
  }
  const brandSchema = yup.object().shape(validationObject);


  const handleFormSubmit = async (values) => {
    setProgressDialogOpen(true);
    if (type === "new") {
      if (values.website.charAt(values.website.length - 1) !== "/") {
        values.website = values.website + "/";
      }
      const data = {
        brandLogo: values.logoSquare,
        horizontalLogo: values.logoHorizontal,
        bigHorizontalLogo: values.logoHorizontalBig,
        verticalLogo: values.logoVertical,
        stripLogo: values.logoStrip,
        brand: {
          name: values.brandName,
          description: values.brandDescription,
          website: values.website,
          webservice_provider: values.webservice_provider,
          webservice_address: values.webservice_address,
          webservice_username: values.webservice_username,
          webservice_password: values.webservice_password,
          client_id: values.client_id,
          client_secret: values.client_secret,
          legal_name: values.legal_name,
          tax_no: values.tax_no,
          company_address: values.company_address,
          company_phone_number: values.company_phone_number,
          company_email: values.company_email,
          company_kep: values.company_kep,
          return_email: values.return_email,
          return_address: values.return_address,
          sales_type: values.sales_type,
          keywords: values.keywords.join(";")
        },
        brand_account: {
          name: values.name,
          surname: values.surname,
          email: values.email,
          password: values.password,
        }
      };

      if (isAddingFromAdminPanel) {
        data.brand.is_active = 1;
        data.brand_account.is_approved = 1;
        data.brand.commission_percentage = values.commission;
        data.brand.coupon_distribution_percentage = values.couponDistributionPercentage;
        data.brand.conversion_percentage = values.conversionPercentage;
        data.brand.avarage_basket_amount = values.avarageBasketAmount;
        data.brand.sector_name = values.sectorName;
      } else {
        data.brand.commission_percentage = 0;
      }

      let canContinue = true;
      if (values.refCode && values.refCode !== "") {
        await axios.get(`${process.env.REACT_APP_API_URL}api/alcago/partner/checkRefCodeExists`, { params: { refCode: values.refCode } })
          .catch((err) => {
            console.log("err: " + err);
            setAlertMessage("Referans kodu hatalı.");
            setTimeout(() => {
              setAlertMessage(null)
            }, 3000);
            canContinue = false;
            setProgressDialogOpen(false);
          })
          .then((response) => {
            if (response && response.data.success === true && response.data.status === 200 && response.data.isExists) {
              data.brand.partner_ref_id = response.data.refCodeId;
            }
          });
      }

      if (canContinue) {
        await axios.patch(`${process.env.REACT_APP_API_URL}api/alcago/brand/validateUserData`, {
          name: data.brand.name,
          website: data.brand.website,
          email: data.brand_account.email
        })
          .catch((err) => {
            console.log("err: " + err);
            setProgressDialogOpen(false);
          })
          .then((response) => {
            if (response && response.data.success === true && response.data.status === 200) {
              if (response.data.isValid) {
                setData(data);
                axios.post(`${process.env.REACT_APP_API_URL}api/alcago/brand/`, data, {
                  headers: {
                    "content-type": "multipart/form-data"
                  },
                  onUploadProgress: (progressEvent) => {
                    const progressOnUpload = (progressEvent.loaded / progressEvent.total) * 100;
                    setTimeout(() => {
                      setProgress(progressOnUpload / 3);
                    }, 500);
                    setTimeout(() => {
                      setProgress(progressOnUpload * 2 / 3);
                    }, 1000);
                    setTimeout(() => {
                      setProgress(progressOnUpload);
                    }, 1500);
                  }
                })
                  .catch((err) => {
                    console.log("err: " + err);
                    setAlertMessage("Bir hata oluştu");
                    setProgressDialogOpen(false);
                    setTimeout(() => {
                      setAlertMessage(null)
                    }, 3000);
                  })
                  .then((response) => {
                    if (response && response.data.success === true && response.data.status === 201) {

                    }
                  });
              } else {
                setAlertMessage(response.data.unvalidField + ' ("' + response.data.unvalidValue + '") zaten kullanılıyor.');
                setProgressDialogOpen(false);
              }
            }
          });
      }
    } else if (type === "edit" || type === "approve") {
      const data = {
        brand: {
          name: values.brandName,
          description: values.brandDescription,
          website: values.website,
          keywords: values.keywords.join(";"),
          commission_percentage: values.commission,
          coupon_distribution_percentage: values.couponDistributionPercentage,
          conversion_percentage: values.conversionPercentage,
          avarage_basket_amount: values.avarageBasketAmount,
          sector_name: values.sectorName
        }
      }
      if (type === "approve") {
        data.brand.is_active = 1
      }
      if (values.logoSquare) {
        await axios.post(`${process.env.REACT_APP_API_URL}api/alcago/brand/uploadBrandLogo?token=${token}`, { brandLogo: values.logoSquare }, {
          headers: {
            "content-type": "multipart/form-data"
          },
        }).then((response) => {
          if (response && response.data.success === true && response.data.status === 201) {
            data.brand.logo_path = response.data.logoPath;
          }
        });
      }
      if (values.logoHorizontal) {
        await axios.post(`${process.env.REACT_APP_API_URL}api/alcago/brand/uploadHorizontalLogo?token=${token}`, { horizontalLogo: values.logoHorizontal }, {
          headers: {
            "content-type": "multipart/form-data"
          },
        }).then((response) => {
          if (response && response.data.success === true && response.data.status === 201) {
            data.brand.horizontal_logo_path = response.data.logoPath;
          }
        });
      }
      if (values.logoHorizontalBig) {
        await axios.post(`${process.env.REACT_APP_API_URL}api/alcago/brand/uploadBigHorizontalLogo?token=${token}`, { bigHorizontalLogo: values.logoHorizontalBig }, {
          headers: {
            "content-type": "multipart/form-data"
          },
        }).then((response) => {
          if (response && response.data.success === true && response.data.status === 201) {
            data.brand.big_horizontal_logo_path = response.data.logoPath;
          }
        });
      }
      if (values.logoStrip) {
        await axios.post(`${process.env.REACT_APP_API_URL}api/alcago/brand/uploadStripLogo?token=${token}`, { stripLogo: values.logoStrip }, {
          headers: {
            "content-type": "multipart/form-data"
          },
        }).then((response) => {
          if (response && response.data.success === true && response.data.status === 201) {
            data.brand.strip_logo_path = response.data.logoPath;
          }
        });
      }
      if (values.logoVertical) {
        await axios.post(`${process.env.REACT_APP_API_URL}api/alcago/brand/uploadVerticalLogo?token=${token}`, { verticalLogo: values.logoVertical }, {
          headers: {
            "content-type": "multipart/form-data"
          },
          onUploadProgress: (progressEvent) => {
            const progressOnUpload = (progressEvent.loaded / progressEvent.total) * 100;
            setTimeout(() => {
              setProgress(progressOnUpload / 3);
            }, 500);
            setTimeout(() => {
              setProgress(progressOnUpload * 2 / 3);
            }, 1000);
            setTimeout(() => {
              setProgress(progressOnUpload);
            }, 1500);
          }
        }).then((response) => {
          if (response && response.data.success === true && response.data.status === 201) {
            data.brand.vertical_logo_path = response.data.logoPath;
          }
        });
      } else {
        setTimeout(() => {
        }, 500);
        setTimeout(() => {
          setProgress(66);
        }, 1000);
        setTimeout(() => {
          setProgress(100);
        }, 1500);
      }

      await axios.patch(`${process.env.REACT_APP_API_URL}api/alcago/brand/updateBrand?token=${token}&brandId=${brand.id}`, data)
        .then((response) => {
          if (response && response.data.success === true && response.data.status === 201) {

          }
        });
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth={"md"} open={open} onClose={handleClose}>
        <Box minWidth="500px" m="20px" mb="5px" textAlign="center">
          {type === "new" && !isAddingFromAdminPanel &&
            <Typography variant='h2'>Kayıt</Typography>
          }
          {type === "new" && isAddingFromAdminPanel &&
            <Typography variant='h2'>Yeni Marka</Typography>
          }
          {type === "edit" &&
            <Typography variant='h2'>Markayı Düzenle</Typography>
          }
          {type === "approve" &&
            <Typography variant='h2'>Markayı Onayla</Typography>
          }

          {alertMessage && <Alert severity="error" sx={{ marginTop: "20px" }}>{alertMessage}</Alert>}

        </Box>

        <DialogContent>
          <Formik
            onSubmit={handleFormSubmit}
            initialValues={initialValues}
            validationSchema={brandSchema}
          >
            {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
              <form onSubmit={handleSubmit}>
                <Box display="grid" gap="30px" gridTemplateColumns="repeat(6, minmax(0, 1fr))">
                  <Box display="grid" gap="30px" gridTemplateColumns="repeat(5, minmax(0, 1fr))" style={{ gridColumn: "span 6" }}>
                    <Button variant="contained" component="label" style={{ gridColumn: "span 1", textAlign: "center" }}>
                      {(!values.logoSquare && !(values.logoSquareLink && values.logoSquareLink !== "")) && <span>Logo Yükle</span>}
                      <br />
                      {(!values.logoSquare && !(values.logoSquareLink && values.logoSquareLink !== "")) && <span>(1080 x 1080)</span>}
                      {(values.logoSquare || (values.logoSquareLink && values.logoSquareLink !== "")) && <img alt='square brand logo' height="100px" width="100px" src={values.logoSquare ? URL.createObjectURL(values.logoSquare) : values.logoSquareLink} />}
                      <input id="logoSquare" name="logoSquare" type="file" accept=".png, .jpeg, .jpg" onChange={(event) => { setFieldValue("logoSquare", event.target.files[0]); }} hidden />
                    </Button>
                    <Button variant="contained" component="label" style={{ gridColumn: "span 1", textAlign: "center" }}>
                      {(!values.logoHorizontal && !(values.logoHorizontalLink && values.logoHorizontalLink !== "")) && <span>Logo Yükle</span>}
                      <br />
                      {(!values.logoHorizontal && !(values.logoHorizontalLink && values.logoHorizontalLink !== "")) && <span>(350 x 300)</span>}
                      {(values.logoHorizontal || (values.logoHorizontalLink && values.logoHorizontalLink !== "")) && <img alt='horizontal brand logo' height="85px" width="100px" src={values.logoHorizontal ? URL.createObjectURL(values.logoHorizontal) : values.logoHorizontalLink} />}
                      <input id="logoHorizontal" name="logoHorizontal" type="file" accept=".png, .jpeg, .jpg" onChange={(event) => { setFieldValue("logoHorizontal", event.target.files[0]); }} hidden />
                    </Button>
                    <Button variant="contained" component="label" style={{ gridColumn: "span 1", textAlign: "center" }}>
                      {(!values.logoHorizontalBig && !(values.logoHorizontalBigLink && values.logoHorizontalBigLink !== "")) && <span>Logo Yükle</span>}
                      <br />
                      {(!values.logoHorizontalBig && !(values.logoHorizontalBigLink && values.logoHorizontalBigLink !== "")) && <span>(1080 x 720)</span>}
                      {(values.logoHorizontalBig || (values.logoHorizontalBigLink && values.logoHorizontalBigLink !== "")) && <img alt='big horiziontal brand logo' height="66px" width="100px" src={values.logoHorizontalBig ? URL.createObjectURL(values.logoHorizontalBig) : values.logoHorizontalBigLink} />}
                      <input id="logoHorizontalBig" name="logoHorizontalBig" type="file" accept=".png, .jpeg, .jpg" onChange={(event) => { setFieldValue("logoHorizontalBig", event.target.files[0]); }} hidden />
                    </Button>
                    <Button variant="contained" component="label" style={{ gridColumn: "span 1", textAlign: "center" }}>
                      {(!values.logoVertical && !(values.logoVerticalLink && values.logoVerticalLink !== "")) && <span>Logo Yükle</span>}
                      <br />
                      {(!values.logoVertical && !(values.logoVerticalLink && values.logoVerticalLink !== "")) && <span>(270 x 400)</span>}
                      {(values.logoVertical || (values.logoVerticalLink && values.logoVerticalLink !== "")) && <img alt='vertical brand logo' height="100px" width="67px" src={values.logoVertical ? URL.createObjectURL(values.logoVertical) : values.logoVerticalLink} />}
                      <input id="logoVertical" name="logoVertical" type="file" accept=".png, .jpeg, .jpg" onChange={(event) => { setFieldValue("logoVertical", event.target.files[0]); }} hidden />
                    </Button>
                    <Button variant="contained" component="label" style={{ gridColumn: "span 1", textAlign: "center" }}>
                      {(!values.logoStrip && !(values.logoStripLink && values.logoStripLink !== "")) && <span>Logo Yükle</span>}
                      <br />
                      {(!values.logoStrip && !(values.logoStripLink && values.logoStripLink !== "")) && <span>(560 x 190)</span>}
                      {(values.logoStrip || (values.logoStripLink && values.logoStripLink !== "")) && <img alt='Strip brand logo' height="38px" width="112px" src={values.logoStrip ? URL.createObjectURL(values.logoStrip) : values.logoStripLink} />}
                      <input id="logoStrip" name="logoStrip" type="file" accept=".png, .jpeg, .jpg" onChange={(event) => { setFieldValue("logoStrip", event.target.files[0]); }} hidden />
                    </Button>
                  </Box>
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Marka Adı"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.brandName}
                    name="brandName"
                    error={!!touched.brandName && !!errors.brandName}
                    helperText={touched.brandName && errors.brandName}
                    sx={{ gridColumn: "span 3" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Website"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.website}
                    name="website"
                    error={!!touched.website && !!errors.website}
                    helperText={touched.website && errors.website}
                    sx={{ gridColumn: "span 3" }}
                  />
                  {(type === "approve" || type === "edit" || (type === "new" && isAddingFromAdminPanel)) &&
                    <TextField
                      fullWidth
                      variant="filled"
                      type="number"
                      label="Komisyon Yüzdesi"
                      onBlur={handleBlur}
                      onChange={(e) => {
                        if (e.target.value >= 0 && e.target.value <= 100) {
                          handleChange(e);
                        }
                      }}
                      value={values.commission}
                      name="commission"
                      error={!!touched.commission && !!errors.commission}
                      helperText={touched.commission && errors.commission}
                      sx={{ gridColumn: "span 3" }}
                    />
                  }
                  {(type === "approve" || type === "edit" || (type === "new" && isAddingFromAdminPanel)) &&
                    <Box gridColumn={"span 3"} />
                  }

                  {(type === "approve" || type === "edit" || (type === "new" && isAddingFromAdminPanel)) &&
                    <TextField
                      fullWidth
                      variant="filled"
                      type="text"
                      label="Sektör Adı"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.sectorName}
                      name="sectorName"
                      error={!!touched.sectorName && !!errors.sectorName}
                      helperText={touched.sectorName && errors.sectorName}
                      sx={{ gridColumn: "span 3" }}
                    />
                  }
                  {(type === "approve" || type === "edit" || (type === "new" && isAddingFromAdminPanel)) &&
                    <TextField
                      fullWidth
                      variant="filled"
                      type="number"
                      label="Kupon Dağıtım Oranı(%)"
                      onBlur={handleBlur}
                      onChange={(e) => {
                        if (e.target.value >= 0 && e.target.value <= 100) {
                          handleChange(e);
                        }
                      }}
                      value={values.couponDistributionPercentage}
                      name="couponDistributionPercentage"
                      error={!!touched.couponDistributionPercentage && !!errors.couponDistributionPercentage}
                      helperText={touched.couponDistributionPercentage && errors.couponDistributionPercentage}
                      sx={{ gridColumn: "span 3" }}
                    />
                  }
                  {(type === "approve" || type === "edit" || (type === "new" && isAddingFromAdminPanel)) &&
                    <TextField
                      fullWidth
                      variant="filled"
                      type="number"
                      label="Kupon Kullanım Oranı(%)"
                      onBlur={handleBlur}
                      onChange={(e) => {
                        if (e.target.value >= 0 && e.target.value <= 100) {
                          handleChange(e);
                        }
                      }}
                      value={values.conversionPercentage}
                      name="conversionPercentage"
                      error={!!touched.conversionPercentage && !!errors.conversionPercentage}
                      helperText={touched.conversionPercentage && errors.conversionPercentage}
                      sx={{ gridColumn: "span 3" }}
                    />
                  }
                  {(type === "approve" || type === "edit" || (type === "new" && isAddingFromAdminPanel)) &&
                    <TextField
                      fullWidth
                      variant="filled"
                      type="number"
                      label="Ortalama Sepet Tutarı(₺)"
                      onBlur={handleBlur}
                      onChange={(e) => {
                        if (e.target.value >= 0) {
                          handleChange(e);
                        }
                      }}
                      value={values.avarageBasketAmount}
                      name="avarageBasketAmount"
                      error={!!touched.avarageBasketAmount && !!errors.avarageBasketAmount}
                      helperText={touched.avarageBasketAmount && errors.avarageBasketAmount}
                      sx={{ gridColumn: "span 3" }}
                    />
                  }
                  <TextField
                    fullWidth
                    multiline
                    variant="filled"
                    type="text"
                    label="Marka Tanıtımı"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.brandDescription}
                    name="brandDescription"
                    rows={4}
                    error={!!touched.brandDescription && !!errors.brandDescription}
                    helperText={touched.brandDescription && errors.brandDescription}
                    sx={{ gridColumn: "span 6" }}
                  />

                  <Autocomplete
                    multiple
                    id="tags-filled"
                    options={[]}
                    freeSolo
                    onChange={(e, value) => setFieldValue("keywords", value)}
                    value={values.keywords}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        multiline
                        variant="filled"
                        type="text"
                        label={<><span>Anahtar Kelimeler</span><span style={{ fontSize: "10px" }}> (Kelimeyi girdikten sonra enter tuşuna basarak onaylayabilirsiniz.)</span></>}
                        error={!!touched.keywords && !!errors.keywords}
                        helperText={touched.keywords && errors.keywords}
                      />
                    )}
                    sx={{ gridColumn: "span 6" }}
                  />

                  {type === "new" &&
                    <>
                      <TextField
                        fullWidth
                        variant="filled"
                        type="text"
                        label="Referans Kodu (İsteğe Bağlı)"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.refCode}
                        name="refCode"
                        error={!!touched.refCode && !!errors.refCode}
                        helperText={touched.refCode && errors.refCode}
                        sx={{ gridColumn: "span 3" }}
                        inputProps={{ maxLength: 100 }}
                      />
                      <br />
                      <TextField
                        fullWidth
                        variant="filled"
                        type="text"
                        label="İsim"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.name}
                        name="name"
                        error={!!touched.name && !!errors.name}
                        helperText={touched.name && errors.name}
                        sx={{ gridColumn: "span 3" }}
                      />
                      <TextField
                        fullWidth
                        variant="filled"
                        type="text"
                        label="Soyisim"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.surname}
                        name="surname"
                        error={!!touched.surname && !!errors.surname}
                        helperText={touched.surname && errors.surname}
                        sx={{ gridColumn: "span 3" }}
                      />
                      <Box display="flex" alignItems="center" justifyContent="start" padding="16px 10px" gridColumn={"span 3"}>
                        <Checkbox
                          checked={usingProvider}
                          size="small"
                          sx={{
                            padding: "5px 2px 5px 0",
                            '&.Mui-checked': {
                              color: (colors.greenAccent[200])
                            }
                          }}
                          onClick={(event) => {
                            setUsingProvider(!usingProvider);
                          }}
                        />
                        <Typography variant='h6'>Bir altyapı sağlayıcısı kullanıyorum</Typography>
                      </Box>
                      {usingProvider && <Box gridColumn="span 3">
                        <FormControl fullWidth variant="filled"
                          sx={{ gridColumn: "span 3" }}>
                          <InputLabel id="filter-label" sx={{ fontSize: "10px" }}>Altyapı Sağlayıcısı</InputLabel>
                          <Select
                            labelId="filter-label"
                            label="Altyapı Sağlayıcısı"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            name="webservice_provider"
                            error={!!touched.webservice_provider && !!errors.webservice_provider}
                            helperText={touched.webservice_provider && errors.webservice_provider}
                            value={values.webservice_provider}
                          >
                            <MenuItem value={"tsoft"}>T-Soft</MenuItem>
                            <MenuItem value={"ideasoft"}>IdeaSoft</MenuItem>
                            <MenuItem value={"ikas"}>Ikas</MenuItem>
                            <MenuItem value={"other"}>Diğer</MenuItem>

                          </Select>
                        </FormControl>
                      </Box>}
                      {!usingProvider && <Box gridColumn="span 3"></Box>}
                      {usingProvider && values.webservice_provider && values.webservice_provider === "tsoft" &&
                        <TextField
                          fullWidth
                          variant="filled"
                          type="text"
                          label="Webservis Kullanıcı Adı"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.webservice_username}
                          name="webservice_username"
                          error={!!touched.webservice_username && !!errors.webservice_username}
                          helperText={touched.webservice_username && errors.webservice_username}
                          sx={{ gridColumn: "span 3" }}
                        />
                      }
                      {usingProvider && values.webservice_provider && values.webservice_provider === "tsoft" &&
                        <TextField
                          fullWidth
                          variant="filled"
                          type="password"
                          label="Webservis Kullanıcı Şifresi"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.webservice_password}
                          name="webservice_password"
                          error={!!touched.webservice_password && !!errors.webservice_password}
                          helperText={touched.webservice_password && errors.webservice_password}
                          sx={{ gridColumn: "span 3" }}
                        />
                      }
                      {usingProvider && values.webservice_provider && values.webservice_provider === "tsoft" &&
                        <TextField
                          fullWidth
                          variant="filled"
                          type="text"
                          label="Webservis adresi"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.webservice_address}
                          name="webservice_address"
                          error={!!touched.webservice_address && !!errors.webservice_address}
                          helperText={touched.webservice_address && errors.webservice_address}
                          sx={{ gridColumn: "span 3" }}
                        />
                      }
                      {usingProvider && values.webservice_provider && values.webservice_provider === "tsoft" && <Box gridColumn="span 3"></Box>}

                      {usingProvider && values.webservice_provider && values.webservice_provider === "ikas" &&
                        <TextField
                          fullWidth
                          variant="filled"
                          type="text"
                          label="Client ID"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.client_id}
                          name="client_id"
                          error={!!touched.client_id && !!errors.client_id}
                          helperText={touched.client_id && errors.client_id}
                          sx={{ gridColumn: "span 3" }}
                        />
                      }
                      {usingProvider && values.webservice_provider && values.webservice_provider === "ikas" &&
                        <TextField
                          fullWidth
                          variant="filled"
                          type="text"
                          label="Client Secret"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.client_secret}
                          name="client_secret"
                          error={!!touched.client_secret && !!errors.client_secret}
                          helperText={touched.client_secret && errors.client_secret}
                          sx={{ gridColumn: "span 3" }}
                        />
                      }

                      {usingProvider && values.webservice_provider && values.webservice_provider === "ikas" &&
                        <TextField
                          fullWidth
                          variant="filled"
                          type="text"
                          label="Mağaza Adı"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.webservice_username}
                          name="webservice_username"
                          error={!!touched.webservice_username && !!errors.webservice_username}
                          helperText={touched.webservice_username && errors.webservice_username}
                          sx={{ gridColumn: "span 3" }}
                        />
                      }
                      {usingProvider && values.webservice_provider && values.webservice_provider === "ikas" && <Box gridColumn="span 3"></Box>}

                      <TextField
                        fullWidth
                        variant="filled"
                        type="text"
                        label="Yasal Firma Adı"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.legal_name}
                        name="legal_name"
                        error={!!touched.legal_name && !!errors.legal_name}
                        helperText={touched.legal_name && errors.legal_name}
                        sx={{ gridColumn: "span 3" }}
                      />

                      <TextField
                        fullWidth
                        variant="filled"
                        type="text"
                        label="Vergi Numarası"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.tax_no}
                        name="tax_no"
                        error={!!touched.tax_no && !!errors.tax_no}
                        helperText={touched.tax_no && errors.tax_no}
                        sx={{ gridColumn: "span 3" }}
                      />

                      <TextField
                        fullWidth
                        variant="filled"
                        type="text"
                        label="Firma Adresi"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.company_address}
                        name="company_address"
                        error={!!touched.company_address && !!errors.company_address}
                        helperText={touched.company_address && errors.company_address}
                        sx={{ gridColumn: "span 6" }}
                      />

                      <TextField
                        fullWidth
                        variant="filled"
                        type="text"
                        label="Firma Telefon Numarası"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.company_phone_number}
                        name="company_phone_number"
                        error={!!touched.company_phone_number && !!errors.company_phone_number}
                        helperText={touched.company_phone_number && errors.company_phone_number}
                        sx={{ gridColumn: "span 3" }}
                      />

                      <TextField
                        fullWidth
                        variant="filled"
                        type="email"
                        label="Firma Eposta"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.company_email}
                        name="company_email"
                        error={!!touched.company_email && !!errors.company_email}
                        helperText={touched.company_email && errors.company_email}
                        sx={{ gridColumn: "span 3" }}
                      />

                      <TextField
                        fullWidth
                        variant="filled"
                        type="email"
                        label="Firma KEP Adresi"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.company_kep}
                        name="company_kep"
                        error={!!touched.company_kep && !!errors.company_kep}
                        helperText={touched.company_kep && errors.company_kep}
                        sx={{ gridColumn: "span 3" }}
                      />

                      <TextField
                        fullWidth
                        variant="filled"
                        type="email"
                        label="İade Eposta"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.return_email}
                        name="return_email"
                        error={!!touched.return_email && !!errors.return_email}
                        helperText={touched.return_email && errors.return_email}
                        sx={{ gridColumn: "span 3" }}
                      />

                      <TextField
                        fullWidth
                        variant="filled"
                        type="text"
                        label="İade Adresi"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.return_address}
                        name="return_address"
                        error={!!touched.return_address && !!errors.return_address}
                        helperText={touched.return_address && errors.return_address}
                        sx={{ gridColumn: "span 6" }}
                      />

                      <FormControl fullWidth variant="filled"
                        sx={{ gridColumn: "span 3" }}>
                        <InputLabel id="filter-label" sx={{ fontSize: "10px" }}>Satış Türü</InputLabel>
                        <Select
                          labelId="filter-label"
                          label="Satış Türü"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          name="sales_type"
                          error={!!touched.sales_type && !!errors.sales_type}
                          helperText={touched.sales_type && errors.sales_type}
                          value={values.sales_type}
                        >
                          <MenuItem value={"digital"}>E-ticaret</MenuItem>
                          <MenuItem value={"physical"}>Yerel hizmet</MenuItem>

                        </Select>
                      </FormControl>
                      <Box gridColumn="span 3"></Box>

                      <TextField
                        fullWidth
                        variant="filled"
                        type="email"
                        label="Eposta"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.email}
                        name="email"
                        error={!!touched.email && !!errors.email}
                        helperText={touched.email && errors.email}
                        sx={{ gridColumn: "span 3" }}
                      />
                      <br />
                      <TextField
                        fullWidth
                        variant="filled"
                        type="password"
                        label="Şifre"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.password}
                        name="password"
                        error={!!touched.password && !!errors.password}
                        helperText={touched.password && errors.password}
                        sx={{ gridColumn: "span 3" }}
                      />
                      <TextField
                        fullWidth
                        variant="filled"
                        type="password"
                        label="Şifre"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.passwordCheck}
                        name="passwordCheck"
                        error={!!touched.passwordCheck && !!errors.passwordCheck}
                        helperText={touched.passwordCheck && errors.passwordCheck}
                        sx={{ gridColumn: "span 3" }}
                      />
                    </>
                  }
                </Box>
                <Box display="flex" justifyContent="end" m="20px 20px 0px 20px">
                  <Button type="submit" color="secondary" variant="contained" onClick={() => {
                    console.log(errors);
                  }}>
                    {type === "new" && !isAddingFromAdminPanel &&
                      <Typography variant='h5'>Başvur</Typography>
                    }
                    {((type === "new" && isAddingFromAdminPanel) || type === "edit") &&
                      <Typography variant='h5'>Kaydet</Typography>
                    }
                    {type === "approve" &&
                      <Typography variant='h5'>Onayla</Typography>
                    }
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Dialog >
      <ProgressDialog open={progressDialogOpen} progress={progress} />
    </>
  )
}

export default RegisterDialog;